export const MANIFESTO = {
  fr: {
    label: "Le manifeste du gérant",
    lines: [
      "Ici, chaque assiette raconte la vallée.",
      "Nous travaillons avec les producteurs du Haut-Bréda et de Belledonne : le pain, les fromages, les légumes et les viandes viennent d'ici, ou de tout près.",
      "Circuits courts, saisonnalité, zéro superflu : notre cuisine respecte la montagne qui nous nourrit.",
      "Et parce qu'une maison ne vaut que par l'accueil qu'elle offre, nous vous recevrons comme des amis — été comme hiver.",
    ],
    author: "Jean-Philippe Vacher",
    role: "Gérant",
  },
  en: {
    label: "The manager's manifesto",
    lines: [
      "Here, every plate tells the story of the valley.",
      "We work with the producers of Haut-Bréda and Belledonne: bread, cheeses, vegetables and meats come from here, or from very close by.",
      "Short supply chains, seasonality, nothing superfluous: our cooking respects the mountains that feed us.",
      "And because a house is only worth the welcome it offers, we will greet you like friends — summer and winter alike.",
    ],
    author: "Jean-Philippe Vacher",
    role: "Managing Partner",
  },
  es: {
    label: "El manifiesto del gerente",
    lines: [
      "Aquí, cada plato cuenta la historia del valle.",
      "Trabajamos con los productores de Haut-Bréda y Belledonne: el pan, los quesos, las verduras y las carnes vienen de aquí, o de muy cerca.",
      "Circuitos cortos, temporada, nada superfluo: nuestra cocina respeta la montaña que nos alimenta.",
      "Y porque una casa solo vale por la acogida que ofrece, les recibiremos como amigos — en verano como en invierno.",
    ],
    author: "Jean-Philippe Vacher",
    role: "Gerente",
  },
  de: {
    label: "Das Manifest des Geschäftsführers",
    lines: [
      "Hier erzählt jeder Teller die Geschichte des Tals.",
      "Wir arbeiten mit den Erzeugern von Haut-Bréda und Belledonne: Brot, Käse, Gemüse und Fleisch kommen von hier — oder aus nächster Nähe.",
      "Kurze Wege, Saisonalität, nichts Überflüssiges: Unsere Küche respektiert die Berge, die uns ernähren.",
      "Und weil ein Haus nur so viel wert ist wie sein Empfang, heißen wir Sie willkommen wie Freunde — im Sommer wie im Winter.",
    ],
    author: "Jean-Philippe Vacher",
    role: "Geschäftsführer",
  },
  it: {
    label: "Il manifesto dell'amministratore",
    lines: [
      "Qui ogni piatto racconta la storia della valle.",
      "Lavoriamo con i produttori di Haut-Bréda e del Belledonne: pane, formaggi, verdure e carni vengono da qui, o da molto vicino.",
      "Filiere corte, stagionalità, niente superfluo: la nostra cucina rispetta la montagna che ci nutre.",
      "E perché una casa vale solo per l'accoglienza che offre, vi accoglieremo come amici — d'estate come d'inverno.",
    ],
    author: "Jean-Philippe Vacher",
    role: "Amministratore",
  },
  nl: {
    label: "Het manifest van de zaakvoerder",
    lines: [
      "Hier vertelt elk bord het verhaal van de vallei.",
      "Wij werken met de producenten van Haut-Bréda en Belledonne: brood, kazen, groenten en vlees komen van hier, of van heel dichtbij.",
      "Korte ketens, seizoensgebonden, niets overbodigs: onze keuken respecteert de bergen die ons voeden.",
      "En omdat een huis alleen zoveel waard is als het welkom dat het biedt, ontvangen wij u als vrienden — zomer en winter.",
    ],
    author: "Jean-Philippe Vacher",
    role: "Zaakvoerder",
  },
  ru: {
    label: "Манифест директора",
    lines: [
      "Здесь каждая тарелка рассказывает историю долины.",
      "Мы работаем с производителями От-Бреда и Белледонна: хлеб, сыры, овощи и мясо — отсюда или из ближайших окрестностей.",
      "Короткие цепочки поставок, сезонность, ничего лишнего: наша кухня уважает горы, которые нас кормят.",
      "А потому что дом ценен лишь своим гостеприимством, мы встретим вас как друзей — летом и зимой.",
    ],
    author: "Жан-Филипп Ваше",
    role: "Директор",
  },
  uk: {
    label: "Маніфест директора",
    lines: [
      "Тут кожна страва розповідає історію долини.",
      "Ми працюємо з виробниками От-Бреда та Белледонну: хліб, сири, овочі та м'ясо — звідси або з найближчих околиць.",
      "Короткі ланцюги постачання, сезонність, нічого зайвого: наша кухня поважає гори, які нас годують.",
      "А оскільки дім вартий лише своєї гостинності, ми зустрічатимемо вас як друзів — влітку та взимку.",
    ],
    author: "Жан-Філіпп Ваше",
    role: "Директор",
  },
};
